import React from "react";
import HeaderOne from "../Components/Header/HeaderOne";
import BannerOne from "../Components/Banner/BannerOne";
import CategoryOne from "../Components/Category/CategoryOne";
import DestinationOne from "../Components/Destination/DestinationOne";
import AboutOne from "../Components/About/AboutOne";
import TourOne from "../Components/Tour/TourOne";
import TestimonialOne from "../Components/Testimonials/TestimonialOne";
import FooterOne from "../Components/Footer/FooterOne";
import ScrollToTop from "../Components/ScrollToTop";
import { Helmet } from "react-helmet-async";

function HomeOne() {
  return (
    <div>
      <Helmet>
        <title>Printers Friendly</title>
      </Helmet>
      <HeaderOne />
      <BannerOne />
      <CategoryOne />
      <DestinationOne />
      <AboutOne />
      <TourOne />
      <TestimonialOne />
      <FooterOne />
      <ScrollToTop />
    </div>
  );
}

export default HomeOne;
